import { PageWindowCache } from './list-cache.js';
import { deriveHistoryCacheCap } from './history-cache.js';
import type { SDKStorage } from '../storage/types.js';
import type { ListFeedHomeResponse } from '../types/feed.js';

/**
 * Feed home page-window cache: one `listHome` page window per cursor, the same
 * persisted/live split as every other lane — the live `sdk.feed.connect()`
 * semantics are untouched; feed events and the owner's own feed mutations
 * invalidate.
 */
export class FeedCache {
  private pages: PageWindowCache<ListFeedHomeResponse>;

  constructor(capEntries: number = deriveHistoryCacheCap(), storage: SDKStorage | null = null) {
    this.pages = new PageWindowCache<ListFeedHomeResponse>(capEntries, 'feed:', storage);
  }

  prepare(identity: string): void {
    this.pages.prepare(identity);
  }

  lookup(identity: string, key: string): ListFeedHomeResponse | null {
    return this.pages.lookup(identity, key);
  }

  store(identity: string, key: string, page: ListFeedHomeResponse): void {
    this.pages.store(identity, key, page);
  }

  /** Feed events landed or the owner mutated — every home window refetches. */
  evictAll(): void {
    this.pages.evictAll();
  }
}
